// Vite entrypoint for the profile page — edit user preferences.
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import '../css/style.css'
import '../js/components'
import { initAppsignal } from '../js/shared/appsignal.ts'
import { initI18n } from '../js/shared/i18n.ts'
import { initProfilePage } from '../js/pages/profile.ts'

initAppsignal()

document.addEventListener('DOMContentLoaded', async () => {
  await initI18n()
  initProfilePage()
})
